import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useModal } from '../../../../../store/ModalProvider';
import CustomButton from '../../CustomButton/CustomButton';
import type { NonScheduledDriversModalData } from '../../../../../types/modal';

const dialogShadow =
  '0px 9px 46px 8px rgba(9, 32, 86, 0.12), 0px 24px 38px 3px rgba(9, 32, 86, 0.14), 0px 11px 15px -7px rgba(9, 32, 86, 0.2)';

const CustomModalNonScheduledDrivers: React.FC = () => {
  const { isOpen, closeModal, modalData, modalHandlers } = useModal();
  const data = modalData as NonScheduledDriversModalData | undefined;
  const [handleConfirmAction, handleCancel] = modalHandlers ?? [];

  if (!data) {
    return null;
  }

  const message =
    data.message ??
    'Atualizar folgas atrasadas dos Motoristas Não Escalados?';
  const primaryLabel = data.primaryLabel ?? 'Atualizar';
  const secondaryLabel = data.secondaryLabel ?? 'Cancelar';

  const handleClose = () => {
    if (typeof handleCancel === 'function') {
      handleCancel(data);
    }
    closeModal();
  };

  const handleConfirm = () => {
    if (typeof handleConfirmAction === 'function') {
      handleConfirmAction(data);
    }
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{ pointerEvents: 'auto', zIndex: 2000 }}
      PaperProps={{
        sx: {
          width: 'min(520px, 94vw)',
          borderRadius: '8px',
          background:
            'linear-gradient(180deg, rgba(255, 242, 234, 0.9) 0%, #FFFFFF 60%)',
          boxShadow: dialogShadow,
          overflow: 'hidden',
          zIndex: 2001,
        },
      }}
    >
      <Box sx={{ fontFamily: 'Poppins, sans-serif', color: '#092056' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '24px' }}>
          <Box
            sx={{
              width: '64px',
              height: '64px',
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(140deg, #F4811F 0%, #F6B266 100%)',
              boxShadow: '0 10px 18px rgba(244, 129, 31, 0.3)',
            }}
          >
            <WarningAmberRoundedIcon sx={{ fontSize: 34, color: '#FFFFFF' }} />
          </Box>
        </Box>
        <Box sx={{ padding: '16px 24px 8px' }}>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: 1.6,
              color: '#092056',
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '12px',
            padding: '8px 24px 20px',
          }}
        >
          <CustomButton
            variant="text"
            color="primary"
            onClick={handleClose}
            sx={{
              height: '36px',
              minHeight: '36px',
              padding: '6px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'none',
              color: '#00A5FF',
            }}
          >
            {secondaryLabel}
          </CustomButton>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            sx={{
              height: '36px',
              minHeight: '36px',
              padding: '6px 18px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 8px 16px rgba(9, 32, 86, 0.18)',
              background: '#092056',
              color: '#FFFFFF',
              '&:hover': {
                background: '#08204F',
              },
            }}
          >
            {primaryLabel}
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CustomModalNonScheduledDrivers;
